
const API_BASE = process.env.REACT_APP_STRAPI_API_BASE;

export const apiGet = async (endpoint) => {
  try {
    const res = await fetch(`${API_BASE}${endpoint}`);
    if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
    return await res.json();
  } catch (err) {
    console.error(`GET ${endpoint} failed:`, err);
    throw err;
  }
};
